import type { ApiClient } from "@quotientjs/core"
import type { BrowserContextManager } from "@/clients/browser-context"
import type { Store } from "@/clients/store"

import { People } from "./people"

export class Audience {
  public people: People

  constructor(
    apiClient: ApiClient,
    store: Store,
    browserContext: BrowserContextManager,
  ) {
    this.people = new People(apiClient, store, browserContext)
  }
}
